import { CompanyPackageEntityModel } from "src/store/models/entity/companyPackage/entity";
import { CompanyPackageHelperModel } from "src/store/models/entity/companyPackage/helper";

export const encooCompanyPackageModels = {
  entity: CompanyPackageEntityModel,
  helper: CompanyPackageHelperModel,
};
